import { useEffect } from 'react';

interface UseTabControlProps {
    id: string;
    isCollapsed: boolean;
}

export const useTabControl = ({ id, isCollapsed }: UseTabControlProps) => {
    useEffect(() => {
        const panel = document.getElementById(id);
        if (panel) {
            const focusableElements = panel.querySelectorAll<HTMLElement>('a, button, input, textarea, select, [tabindex]');
            focusableElements.forEach(element => {
                element.tabIndex = isCollapsed ? -1 : 0;
            });
        }
    }, [id, isCollapsed]);
};
